<template>
  <div class="otherFormquote">
    <b-loading :is-full-page="isFullPage" v-model="isLoading"></b-loading>

    <div id="message">
      <b-message title="Demande reçue" type="is-success">
        Merci , un conseiller de capiassur va vous contacter <br />
        Merci de choisir CAPIASSUR.
      </b-message>
    </div>

    <div class="formular" id="formularor">
      <form-wizard
        ref="formwizard"
        @onComplete="onComplete"
        @onNextStep="nextStep"
        @onPreviousStep="previousStep"
        @onReset="reset"
      >
        <tab-content title="Commencer" :selected="true">
          <IntroductionEmprunteur></IntroductionEmprunteur>
          <span v-on:click="Validate1()" id="validation1" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Choose A Or B">
          <div id="choosecartype">
            <h1 class="titleprimary">
              <span class="titlecolorized">Quelle est la nature du</span>
              <span class="titlenoncolorized"> projet ? </span>
            </h1>

            <div class="block blockCenter">
              <div class="columns justufuCenter">
                <div class="column columnSuperDiv">
                  <b-radio
                    v-model="FormularData.NatureProjet"
                    name="owner"
                    value="Nouvel emprunt"
                    class="radioDiv"
                  >
                    <img
                      src="../../assets/imgused/new_assur.png"
                      class="imgradio"
                    />
                    <span class="radiotitlewithimage">Nouvel emprunt</span>
                  </b-radio>
                </div>
                <div class="column columnSuperDiv">
                  <b-radio
                    v-model="FormularData.NatureProjet"
                    name="name"
                    value="Changement Assurance"
                    class="radioDiv"
                  >
                    <img src="../../assets/imgused/updated.png" class="imgradio" />
                    <span class="radiotitlewithimage"
                      >Changement Assurance</span
                    >
                  </b-radio>
                </div>
              </div>
            </div>
          </div>

          <span v-on:click="Validate2()" id="validation2" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Proprietaire">
          <h1 class="titleprimary">
            <span class="titlecolorized">Type de </span>
            <span class="titlenoncolorized">mon projet ?</span>
          </h1>
          <div class="dateElementClass">
            <b-field label="Type de projet">
              <b-select
                placeholder="Type de projet"
                v-model="FormularData.Typerojet"
              >
                <option value="Residence principale">
                  Résidence principale
                </option>
                <option value="Residence secondaire">
                  Résidence secondaire
                </option>
                <option value="Travaux de residence principale">
                  Travaux de résidence principale
                </option>
                <option value="Travaux de residence secondaire">
                  Travaux de résidence secondaire
                </option>
                <option value="Investissement locatif">
                  Investissement locatif
                </option>
                <option value="Pret professionnel ">Prêt professionnel</option>
                <option value="Pret a la consommation">
                  Pret à la consommation
                </option>
                <option value="Autre">Autre</option>
              </b-select>
            </b-field>
          </div>
          <span v-on:click="Validate3()" id="validation3" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="AdresseVehicule">
          <h1 class="titleprimary">
            <span class="titlecolorized">Mon</span>
            <span class="titlenoncolorized"> Adresse?</span>
          </h1>
          <b-field
            label="Trouvez mon adresse"
            :type="{ 'is-danger': Control.CarAdress }"
            :message="{
              'Veuillez cherchez votre adresse': Control.CarAdress,
            }"
          >
            <b-autocomplete
              :data="temporarCodes"
              placeholder="e.g. Paris"
              field="nomCommune"
              :loading="isFetching"
              @typing="getAsyncData"
              @select="(option) => (FormularData.CarAdress = option)"
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-left codepostalCode">
                    {{ props.option.codePostal }}
                  </div>
                  <div class="media-content postalCodeContent">
                    {{ props.option.nomCommune }}

                    <!--
                               <br>
                              <small>
                                {{ props.option.nomCommune }},
                            </small>-->
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <span v-on:click="Validate4()" id="validation4" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Date De Licence">
          <h1 class="titleprimary">
            <span class="titlecolorized">Date D' </span>
            <span class="titlenoncolorized">Effet</span>
          </h1>

          <div class="dateElementClass">
            <b-field>
              <b-datepicker
                :max-date="FormularData.DateEffet"
                v-model="FormularData.DateEffet"
                :show-week-number="Config.showWeekNumber"
                placeholder="Selectionner date d'effet."
                ref="datepicker"
              >
              </b-datepicker>
              <b-button
                @click="$refs.datepicker.toggle()"
                icon-left="calendar-today fa fa-calendar"
                type="is-primary"
              />
            </b-field>
          </div>

          <span v-on:click="Validate5()" id="validation5" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Ma Profession">
          <h1 class="titleprimary">
            <span class="titlecolorized">Ma</span>
            <span class="titlenoncolorized"> Profession ?</span>
          </h1>
          <div class="dateElementClass">
            <b-field label="Status">
              <b-select placeholder="Status" v-model="FormularData.Status">
                <option value="Salarié cadre ingénieur assimilé cadre">
                  Salarié cadre ingénieur assimilé cadre
                </option>
                <option value="Salarié non cadre hors employé de bureau">
                  Salarié non cadre hors employé de bureau
                </option>
                <option value="Employé de bureau">Employé de bureau</option>
                <option value="Dirigeant de société, géant chef d'entreprise">
                  Dirigeant de société, géant chef d'entreprise
                </option>
                <option value="Profession du transport ouvrier technicien">
                  Profession du transport ouvrier technicien
                </option>
                <option value="Profession agricoles">
                  Profession agricoles
                </option>
                <option
                  value="Retraité cadre assimilé cadre, fonctionnaire classe chef d'entreprise"
                >
                  Retraité cadre assimilé cadre, fonctionnaire classe chef
                  d'entreprise
                </option>
                <option value="autre">Autres retraité</option>
              </b-select>
            </b-field>
          </div>

          <div class="emptyspace"></div>

          <b-field
            label="Profession"
            :type="{ 'is-danger': Control.Profession }"
            :message="{
              'Veuillez entrer votre profession': Control.Profession,
            }"
          >
            <b-input
              name="subject"
              v-model="FormularData.Profession"
              expanded
            ></b-input>
          </b-field>

          <span v-on:click="Validate6()" id="validation6" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="About your Futures">
          <h1 class="titleprimary">
            <span class="titlecolorized">Futur</span>
            <span class="titlenoncolorized"> Assurées</span>
          </h1>
          <div class="whoimDiv">
            <b
              class="whoIm"
              type="is-danger"
              message="Entrer le nom de l'assuré"
              >Qui sont les futurs assurés ?
            </b>
            <br />
            <b-checkbox
              v-model="FormularData.Genre"
              value="Monsieur"
              @change.native="ChangeGenre()"
            >
              Monsieur
            </b-checkbox>
            <b-checkbox
              v-model="FormularData.Genre"
              @change.native="ChangeGenre()"
              value="Madame"
            >
              Madame
            </b-checkbox>

            <p class="help is-danger" v-if="Control.Genre">
              Veuillez choisir les futurs assurés<br />
            </p>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="Nom de premier assurée"
                :type="{ 'is-danger': Control.NomAssuree1 }"
                :message="{
                  'Veuillez Entrer le nom du premier Assuré':
                    Control.NomAssuree1,
                }"
              >
                <b-input
                  name="subject"
                  v-model="FormularData.AssureeOne.Nom"
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Prenom de premier assurée"
                :type="{ 'is-danger': Control.PrenomAssuree1 }"
                :message="{
                  'Veuillez Entrer le prenom du premier Assuré':
                    Control.PrenomAssuree1,
                }"
              >
                <b-input
                  name="subject"
                  v-model="FormularData.AssureeOne.Prenom"
                  expanded
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="dateElementClass">
            <b-field
              label="Date de naissance de premier assurée"
              :type="{ 'is-danger': Control.NaissAssuree1 }"
              :message="{
                'Veuillez Choisir la date de naissance nom du premier Assuré':
                  Control.NaissAssuree1,
              }"
            >
              <b-datepicker
                id="naissanceDate"
                ref="datepicker"
                expanded
                v-model="FormularData.AssureeOne.Naissance"
                :max-date="FormularData.AssureeOne.Naissance"
                :show-week-number="Config.showWeekNumber"
                placeholder="Selectionner votre date de naissance."
              >
              </b-datepicker>
              <b-button
                v-on:click="openTogglerDate('naissanceDate')"
                icon-left="calendar-today fa fa-calendar"
                type="is-primary"
              />
            </b-field>
          </div>

          <div id="person2" class="ishidden">
            <div class="emptyspace"></div>
            <div class="columns">
              <div class="column">
                <b-field
                  label="Nom de deuxiéme assurée"
                  :type="{ 'is-danger': Control.NomAssuree2 }"
                  :message="{
                    'Veuillez Entrer le nom du deuxiéme Assuré':
                      Control.NomAssuree2,
                  }"
                >
                  <b-input
                    name="subject"
                    v-model="FormularData.AssureeTwo.Nom"
                    expanded
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  label="Prenom de deuxiéme assurée"
                  :type="{ 'is-danger': Control.PrenomAssuree2 }"
                  :message="{
                    'Veuillez Entrer le prenom du deuxiéme Assuré':
                      Control.PrenomAssuree2,
                  }"
                >
                  <b-input
                    name="subject"
                    v-model="FormularData.AssureeTwo.Prenom"
                    expanded
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div class="dateElementClass">
              <b-field
                label="Date de naissance de deuxiéme assurée"
                :type="{ 'is-danger': Control.NaissAssuree2 }"
                :message="{
                  'Veuillez Choisir la date de naissance nom du deuxiéme Assuré':
                    Control.NaissAssuree2,
                }"
              >
                <b-datepicker
                  id="naissanceDate"
                  ref="datepicker"
                  expanded
                  v-model="FormularData.AssureeTwo.Naissance"
                  :max-date="FormularData.AssureeTwo.Naissance"
                  :show-week-number="Config.showWeekNumber"
                  placeholder="Select a date"
                >
                </b-datepicker>
                <b-button
                  v-on:click="openTogglerDate('naissanceDate')"
                  icon-left="calendar-today fa fa-calendar"
                  type="is-primary"
                />
              </b-field>
            </div>
          </div>

          <span v-on:click="Validate7()" id="validation7" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Fume">
          <h1 class="titleprimary">
            <span class="titlecolorized">Informations</span>
            <span class="titlenoncolorized"> Supplémentaires</span>
          </h1>

          <h6 class="textsubtitle">
            A-t-il
            <span class="colorizedspan"> fumé ou vapoté</span> ces
            <span class="colorizedspan"> deux dernières années </span> ?
          </h6>

          <br />
          <div class="columns">
            <div class="column">
              <b-radio-button
                v-model="FormularData.Fume"
                value="Non"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
            <div class="column">
              <b-radio-button
                v-model="FormularData.Fume"
                value="Oui"
                type="is-success is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Je Confirme</span>
              </b-radio-button>
            </div>
          </div>

          <span v-on:click="Validate8()" id="validation8" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Deplacement">
          <h1 class="titleprimary">
            <span class="titlecolorized">Informations</span>
            <span class="titlenoncolorized"> Supplémentaires</span>
          </h1>

          <h6 class="textsubtitle">
            A-t-il des déplacements professionnels
            <span class="colorizedspan"> > 15 000 km/an</span> ?
          </h6>

          <br />
          <div class="columns">
            <div class="column">
              <b-radio-button
                v-model="FormularData.Deplacement"
                value="Non"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
            <div class="column">
              <b-radio-button
                v-model="FormularData.Deplacement"
                value="Oui"
                type="is-success is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Je Confirme</span>
              </b-radio-button>
            </div>
          </div>

          <span v-on:click="Validate9()" id="validation9" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Demenagement">
          <h1 class="titleprimary">
            <span class="titlecolorized">Informations</span>
            <span class="titlenoncolorized"> Supplémentaires</span>
          </h1>

          <h6 class="textsubtitle">
            A-t-il prévu de
            <span class="colorizedspan"> déménager</span> à l'
            <span class="colorizedspan">étranger</span> ?
          </h6>

          <br />
          <div class="columns">
            <div class="column">
              <b-radio-button
                v-model="FormularData.Demenagement"
                value="Non"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
            <div class="column">
              <b-radio-button
                v-model="FormularData.Demenagement"
                value="Oui"
                type="is-success is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Je Confirme</span>
              </b-radio-button>
            </div>
          </div>

          <span v-on:click="Validate10()" id="validation10" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Poid">
          <h1 class="titleprimary">
            <span class="titlecolorized">Informations</span>
            <span class="titlenoncolorized"> Supplémentaires</span>
          </h1>

          <h6 class="textsubtitle">
            Exerce-t-il une activité avec
            <span class="colorizedspan"> manutention régulière</span> de charges
            <span class="colorizedspan"> lourdes</span> supérieures à
            <span class="colorizedspan"> 15 kg</span> ?
          </h6>

          <br />
          <div class="columns">
            <div class="column">
              <b-radio-button
                v-model="FormularData.Poid"
                value="Non"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
            <div class="column">
              <b-radio-button
                v-model="FormularData.Poid"
                value="Oui"
                type="is-success is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Je Confirme</span>
              </b-radio-button>
            </div>
          </div>

          <span v-on:click="Validate11()" id="validation11" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Hauteur">
          <h1 class="titleprimary">
            <span class="titlecolorized">Informations</span>
            <span class="titlenoncolorized"> Supplémentaires</span>
          </h1>

          <h6 class="textsubtitle">
            Exerce-t-il une activité à

            <span class="colorizedspan"> plus de 15 mètres de hauteur</span> ?
          </h6>

          <br />
          <div class="columns">
            <div class="column">
              <b-radio-button
                v-model="FormularData.Hauteur"
                value="Non"
                type="is-danger is-light is-outlined"
              >
                <i class="fa fa-close"></i>
                <span>Non</span>
              </b-radio-button>
            </div>
            <div class="column">
              <b-radio-button
                v-model="FormularData.Hauteur"
                value="Oui"
                type="is-success is-light is-outlined"
              >
                <i class="fa fa-check"></i>
                <span>Je Confirme</span>
              </b-radio-button>
            </div>
          </div>

          <span v-on:click="Validate12()" id="validation12" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Type de Pret">
          <h1 class="titleprimary">
            <span class="titlecolorized">Type de </span>
            <span class="titlenoncolorized"> prêt</span>
          </h1>

          <div class="dateElementClass">
            <b-field label="Type de prêt">
              <b-select
                class="selectclass"
                placeholder="Type de pret"
                v-model="FormularData.Typepret"
              >
                <option value="Prêt Classique">Prêt Classique</option>
                <option value="Prêt différé">Prêt différé</option>
                <option value="Prêt à taux Zéro">Prêt à taux Zéro</option>
                <option value="Prêt infinie">Prêt infinie</option>
                <option value="Prêt relais">Prêt relais</option>
                <option value="Prêt à palier">Prêt à palier</option>
                <option value="Crédit-bail">Crédit-bail</option>
                <option value="Autre">Autre</option>
              </b-select>
            </b-field>
          </div>

          <div class="emptyspacebetween"></div>

          <div v-if="FormularData.Typepret == 'Autre'">
            <b-field
              label="Autre Type de prêt"
              :type="{ 'is-danger': Control.AutrePret }"
              :message="{
                'Veuillez entrer un autre type de pret': Control.AutrePret,
              }"
            >
              <b-input
                name="subject"
                v-model="FormularData.AutrePret"
                expanded
              ></b-input>
            </b-field>
          </div>

          <span v-on:click="Validate13()" id="validation13" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Organisme de Pret">
          <h1 class="titleprimary">
            <span class="titlecolorized">Organisme</span>
            <span class="titlenoncolorized"> prêteur</span>
          </h1>
          <div class="dateElementClass">
            <b-field label="Rechercher l'organisme prêteur">
              <b-select
                placeholder="Rechercher l'organisme prêteur"
                v-model="FormularData.Organisme"
              >
                <option value="Allianz Banque">Allianz Banque</option>
                <option value="AXA Banque">AXA Banque</option>
                <option value="Banque BCP">Banque BCP</option>
                <option value="Banque Chalus">Banque Chalus</option>
                <option value="Banque Courtois">Banque Courtois</option>
                <option value="Banque de France">Banque de France</option>
                <option value="Banque de savoie">Banque de savoie</option>
                <option value="Banque DUPUV de Parseval">
                  Banque DUPUV de Parseval
                </option>
                <option value="Banque Française mutualiste">
                  Banque Française mutualiste
                </option>
                <option value="Banque KOLB">Banque KOLB</option>
                <option value="Banque Laydernier">Banque Laydernier</option>
                <option value="Banque Marze">Banque Marze</option>
                <option value="Banque Nuger">Banque Nuger</option>
                <option value="Banque Platine">Banque Platine</option>
                <option value="Banque Populaire">Banque Populaire</option>
                <option value="BRED">BRED</option>
                <option value="Banque Postale">Banque Postale</option>
                <option value="Banque Privée Européenne">
                  Banque Privée Européenne
                </option>
                <option value="Banque Rhone Alpes">Banque Rhone Alpes</option>
                <option value="Banque Tarneaud">Banque Tarneaud</option>
                <option value="BNP">BNP</option>
                <option value="BOURSORAMA">BOURSORAMA</option>
                <option value="Caisse d'épargne">Caisse d'épargne</option>
                <option value="CETELEM">CETELEM</option>
                <option value="CIC">CIC</option>
                <option value="Crédit agricole">Crédit agricole</option>
                <option value="Crédit coopératif">Crédit coopératif</option>
                <option value="Crédit du nord">Crédit du nord</option>
                <option value="Crédit Foncier">Crédit Foncier</option>
                <option value="Crédit immobilier">Crédit immobilier</option>
                <option value="Crédit maritime Grand Ouest">
                  Crédit maritime Grand Ouest
                </option>
                <option value="Crédit Martime Méditerrané">
                  Crédit Martime Méditerrané
                </option>
                <option value="Fortuneo Banque">Fortuneo Banque</option>
                <option value="Groupeama">Groupeama</option>
                <option value="Hello Bank">Hello Bank</option>
                <option value="Hsbc">Hsbc</option>
                <option value="ING direct">ING direct</option>
                <option value="LCL">LCL</option>
                <option value="Monabanq">Monabanq</option>
                <option value="Orange Bank">Orange Bank</option>
                <option value="SBE Bank populaire">SBE Bank populaire</option>
                <option value="Société Générale">Société Générale</option>
                <option value="Société Marseillaise de Crédit">
                  Société Marseillaise de Crédit
                </option>
                <option value="SOCRIF SOFIAP">SOCRIF SOFIAP</option>
                <option value="SOFIDER Océan Indien">
                  SOFIDER Océan Indien
                </option>
                <option value="Autre Banque">Autre Banque</option>
              </b-select>
            </b-field>
          </div>

          <div class="emptyspacebetween"></div>

          <div
            v-if="FormularData.Organisme == 'Autre Banque'"
            :type="{ 'is-danger': Control.AutreOrganisme }"
            :message="{
              'Veuillez entrer une autre organisme': Control.AutreOrganisme,
            }"
          >
            <b-field label="Autre Organisme">
              <b-input
                name="subject"
                v-model="FormularData.AutreOrganisme"
                expanded
              ></b-input>
            </b-field>
          </div>

          <span v-on:click="Validate14()" id="validation14" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Informations de Pret">
          <h1 class="titleprimary">
            <span class="titlecolorized">Organisme</span>
            <span class="titlenoncolorized"> prêteur</span>
          </h1>

          <div class="columns">
            <div class="column">
              <b-field
                label="Montant du prêt (€)"
                :type="{ 'is-danger': Control.Montant }"
                :message="{
                  'Veuillez entrer votre montant du prêt ': Control.Montant,
                }"
              >
                <b-input v-model="FormularData.Montant" min="0"></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Taux du prêt Hors Assurances (%)"
                :type="{ 'is-danger': Control.Taux }"
                :message="{
                  'Veuillez entrer votre taux du prêt  hors assurances: nombres de mois':
                    Control.Taux,
                }"
              >
                <b-input v-model="FormularData.Taux"></b-input>
              </b-field>
            </div>
          </div>

          <div class="emptyspacebetween"></div>

          <b-field
            label="Durée du prêt- hors différé d'amortissement (Mois)"
            :type="{ 'is-danger': Control.Duree }"
            :message="{
              'Veuillez entrer votre durée du prêt : nombres de mois':
                Control.Duree,
            }"
          >
            <b-input v-model="FormularData.Duree"></b-input>
          </b-field>

          <span v-on:click="Validate15()" id="validation15" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Proprietaire">
          <h1 class="titleprimary">
            <span class="titlecolorized">Type de </span>
            <span class="titlenoncolorized">Taux ?</span>
          </h1>

          <div class="block blockCenter">
            <div class="columns justufuCenter">
              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.TypeTaux"
                  name="name"
                  value="Fixe"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/fixe.png" class="imgradio" />
                  <span class="radiotitlewithimage">Fixe</span>
                </b-radio>
              </div>

              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.TypeTaux"
                  name="name"
                  value="Variable"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/variable.png" class="imgradio" />
                  <span class="radiotitlewithimage">Variable</span>
                </b-radio>
              </div>
            </div>
          </div>

          <span v-on:click="Validate16()" id="validation16" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Proprietaire">
          <h1 class="titleprimary">
            <span class="titlecolorized">Type de </span>
            <span class="titlenoncolorized">Taux ?</span>
          </h1>

          <div class="block blockCenter">
            <div class="columns justufuCenter">
              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.Periode"
                  name="name"
                  value="Mensuelle"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/monthly.png" class="imgradio" />
                  <span class="radiotitlewithimage">Mensuelle</span>
                </b-radio>
              </div>

              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.Periode"
                  name="name"
                  value="Trimestrielle"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/trimestre.png" class="imgradio" />
                  <span class="radiotitlewithimage">Trimestrielle</span>
                </b-radio>
              </div>

              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.Periode"
                  name="name"
                  value="Semestrielle"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/semestre.png" class="imgradio" />
                  <span class="radiotitlewithimage">Semestrielle</span>
                </b-radio>
              </div>

              <div class="column columnSuperDiv">
                <b-radio
                  v-model="FormularData.Periode"
                  name="name"
                  value="Annuelle"
                  class="radioDiv"
                >
                  <img src="../../assets/imgused/annuel.png" class="imgradio" />
                  <span class="radiotitlewithimage">Annuelle</span>
                </b-radio>
              </div>
            </div>
          </div>

          <span v-on:click="Validate17()" id="validation17" class="hideclass"
            >Validate</span
          >
        </tab-content>

        <tab-content title="Finishing Up">
          <h1 class="titleprimary">
            <span class="titlecolorized">Mon </span>
            <span class="titlenoncolorized"> Contact</span>
          </h1>
<div v-if="isConnected == 1">
            <b-field
              label="Mon adresse e-mail"
              :type="{ 'is-danger': Control.Email }"
              :message="{ 'Veuillez entrer un email valide': Control.Email }"
            >
              <b-input
                placeholder="Mon adresse e-mail"
                v-model="FormularData.Email"
                type="email"
                icon="fa fa-envelope fa"
                readonly
              >
              </b-input>
            </b-field>

            <b-field
              label="Mon numéro de téléphone"
              :type="{ 'is-danger': Control.Phone }"
              :message="{
                'Veuillez entrer un numéro de téléphone valide': Control.Phone,
              }"
            >
              <b-input
                placeholder="Mon numéro de téléphone"
                v-model="FormularData.Phone"
                type="text"
                icon="fa fa-phone-alt fa"
                icon-right-clickable
                readonly
              >
              </b-input>
            </b-field>
          </div>

          <div v-else>
            <b-field
              label="Mon adresse e-mail"
              :type="{ 'is-danger': Control.Email }"
              :message="{ 'Veuillez entrer un email valide': Control.Email }"
            >
              <b-input
                placeholder="Mon adresse e-mail"
                v-model="FormularData.Email"
                type="email"
                icon="fa fa-envelope fa"
              >
              </b-input>
            </b-field>

            <b-field
              label="Mon numéro de téléphone"
              :type="{ 'is-danger': Control.Phone }"
              :message="{
                'Veuillez entrer un numéro de téléphone valide': Control.Phone,
              }"
            >
              <b-input
                placeholder="Mon numéro de téléphone"
                v-model="FormularData.Phone"
                type="text"
                icon="fa fa-phone-alt fa"
                icon-right-clickable
              >
              </b-input>
            </b-field>
          </div>

          <span v-on:click="Validate18()" id="validation18" class="hideclass"
            >Validate</span
          >

          <h6
          v-on:click="Submit()"
          id="submitform"
          class="hideclass invisibleclass"
        >
          Submit
        </h6>
          
        </tab-content>

      </form-wizard>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IntroductionEmprunteur from "../../components/IntroductionEmprunteur.vue";
import FormWizard from "../../components/FormWizard.vue";
import TabContent from "../../components/TabContent.vue";
import debounce from "lodash/debounce";
import postalCode from "../../assets/postalCode.json";
import ValidationHelper from "../../components/ValidationHelper.vue";
import Buefy from "buefy";
import Vue from "vue";
Vue.use(Buefy, {
  defaultIconPack: "fa",
  defaultContainerElement: "#content",
});

Vue.prototype.$http = axios;

export default {
  name: "SimpleStepperEmprunteur",
  components: {
    FormWizard,
    TabContent,
    IntroductionEmprunteur,
  },
  mixins: [ValidationHelper],
  data() {
    return {
      data: [],
      temporarCodes: [],
      selected: null,
      isFetching: false,
      isFetchingCar: false,
      postalCode: postalCode.Codes,
      maxDate: new Date(),
      Config: {
        showWeekNumber: false,
        currentTab: 0,
      },
      SearchQuery: null,
      ClaimsData: [],
      isFullPage: true,
      isLoading: false,
      Control: {
        Duree: false,
        CarAdress: false,
        Email: false,
        Phone: false,
        NomAssuree: false,
        PrenomAssuree: false,
        Profession: false,
        Montant: false,
        Taux: false,
        AutreOrganisme: false,
        AutrePret: false,
        NomAssuree1: false,
        PrenomAssuree1: false,
        NaissAssuree1: false,
        NomAssuree2: false,
        PrenomAssuree2: false,
        NaissAssuree2: false,
        DateEffet: false,
        CP: false,
        Genre: false,
      },
      M: null,
      M2: null,
      isConnected: 0,
      isReadOnly : false,
      FormularData: {
        Hidden: null,
        isAccount: 1,
        isPro: 0,
        Duree: 0,
        Phone: null,
        Bref: null,
        Email: null,
        Status: "Salarié cadre ingénieur assimilé cadre",
        Profession: "",
        NatureProjet: "Nouvel emprunt",
        Typerojet: "Residence principale",
        Adresse: "",
        DateEffet: new Date(),
        CarAdress: null,
        Genre: ["Monsieur"],
        Typepret: "Prêt Classique",
        AutrePret: "",
        AssureeOne: {
          Nom: "",
          Prenom: "",
          Naissance: new Date(),
        },
        AssureeTwo: {
          Nom: "",
          Prenom: "",
          Naissance: new Date(),
        },
        Hauteur: "Non",
        Poid: "Non",
        Deplacement: "Non",
        Demenagement: "Non",
        Fume: "Non",

        AutreOrganisme: "",
        Organisme: "Allianz Banque",
        Montant: 0,
        Taux: 0,
        Periode: "Mensuelle",

        TypeTaux: "Variable",
      },
    };
  },
  mounted() {
    let today = new Date();
    this.maxDate = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    this.FormularData.AssureeOne.Naissance = this.maxDate;
    this.FormularData.AssureeTwo.Naissance = this.maxDate;
  },

  methods: {
    ChangeGenre() {
      if (this.FormularData.Genre.length == 2) {
        document.getElementById("person2").classList.remove("ishidden");
      } else {
        document.getElementById("person2").classList.add("ishidden");
      }

      if (this.FormularData.Genre.length == 0) {
        this.Control.Genre = true;
      } else {
        this.Control.Genre = false;
      }
    },
    validateStep(id) {
      document
        .getElementById("validation" + id)
        .setAttribute("validation", "validated");
    },
    unvalidateStep(id) {
      document
        .getElementById("validation" + id)
        .setAttribute("validation", "Notvalidated");
    },
    customAlert(msg) {
      this.$buefy.dialog.alert({
        title: "Malhereusement",
        message: msg,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    validatePhone(phone) {
      if (phone.length == 10 && !isNaN(phone)) {
        return false;
      } else {
        return true;
      }
    },
    CheckPhone(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || Element == null || this.validatePhone(Element)) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      if (re.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    CheckDuree(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (isNaN(Element) || parseFloat(Element) <= 0) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },

    CheckTaux(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (isNaN(Element) || parseFloat(Element) < 0) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    CheckEmail(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || this.validateEmail(Element)) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    CheckEntityisNotEmpty(Element) {
      let local = {
        FinalValue: false,
        Control: true,
      };
      local.FinalValue = true;
      if (Element == "" || Element == null) {
        local.FinalValue = false;
        local.Control = true;
      } else {
        local.Control = false;
      }
      return local;
    },
    Validate1() {
      this.validateStep("1");
    },
    Validate2() {
      this.validateStep("2");
    },
    alertCustomError() {
      this.customAlert(
        "Cette fonctionnalité sera <b>prochainement disponible</b>"
      );
    },
    Validate3() {
      this.validateStep("3");
    },
    Validate4() {
      if (this.FormularData.CarAdress != null) {
        this.validateStep("4");
      } else {
        this.customAlert(
          "Vous devez choisir <b>votre adresse postale</b> pour continuer"
        );

        this.unvalidateStep("4");
      }
    },
    Validate5() {
      this.validateStep("5");
    },
    Validate6() {
      let CheckedEntity = this.CheckEntityisNotEmpty(
        this.FormularData.Profession
      );
      let FinalValueProfession = CheckedEntity.FinalValue;
      this.Control.Profession = CheckedEntity.Control;
      if (FinalValueProfession) {
        this.validateStep("6");
      } else {
        this.unvalidateStep("6");
      }
    },
    Validate7() {
      let FinalValue = true;
      let that = this.FormularData;
      let Control = this.Control;
      let Results = [];

      FinalValue = this.CheckEntityisNotEmpty(that.AssureeOne.Nom).FinalValue;
      Results.push(FinalValue);
      Control.NomAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Nom
      ).Control;

      FinalValue = this.CheckEntityisNotEmpty(
        that.AssureeOne.Prenom
      ).FinalValue;
      Results.push(FinalValue);
      Control.PrenomAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Prenom
      ).Control;

      FinalValue = this.CheckEntityisNotEmpty(
        that.AssureeOne.Naissance
      ).FinalValue;
      Results.push(FinalValue);
      Control.NaissAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Naissance
      ).Control;

      if (that.Genre.length == 0) {
        FinalValue = false;
        Results.push(FinalValue);
        Control.Genre = true;
      } else {
        if (that.Genre.length == 2) {
          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Nom
          ).FinalValue;
          Results.push(FinalValue);
          Control.NomAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Nom
          ).Control;

          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Prenom
          ).FinalValue;
          Results.push(FinalValue);
          Control.PrenomAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Prenom
          ).Control;

          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Naissance
          ).FinalValue;
          Results.push(FinalValue);
          Control.NaissAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Naissance
          ).Control;
        }
      }

      let FinalResult = true;
      for (let i = 0; i < Results.length; i++) {
        if (Results[i] == false) {
          FinalResult = false;
        }
      }

      if (FinalResult == true) {
        this.validateStep("7");
      } else {
        this.unvalidateStep("7");
      }
    },
    Validate8() {
      this.validateStep("8");
    },
    Validate9() {
      this.validateStep("9");
    },
    Validate10() {
      this.validateStep("10");
    },
    Validate11() {
      this.validateStep("11");
    },
    Validate12() {
      this.validateStep("12");
    },
    Validate13() {
      let FinalValue = true;
      let that = this.FormularData;
      let Control = this.Control;

      if (that.Typepret == "Autre") {
        FinalValue = this.CheckEntityisNotEmpty(that.AutrePret).FinalValue;

        Control.AutrePret = this.CheckEntityisNotEmpty(that.AutrePret).Control;
      } else {
        Control.AutrePret = true;
      }

      if (FinalValue) {
        this.validateStep("13");
      } else {
        this.unvalidateStep("13");
      }
    },
    Validate14() {
      let FinalValue = true;
      let that = this.FormularData;
      let Control = this.Control;

      if (that.Organisme == "Autre Banque") {
        FinalValue = this.CheckEntityisNotEmpty(that.AutreOrganisme).FinalValue;
        Control.AutreOrganisme = this.CheckEntityisNotEmpty(
          that.AutreOrganisme
        ).Control;
      } else {
        Control.AutreOrganisme = true;
      }

        if (FinalValue) {
          this.validateStep("14");
        } else {
          this.unvalidateStep("14");
        }
      
    },

    Validate15() {
      let FinalValue = null;
      let that = this.FormularData;
      let Control = this.Control;
      let FinalValueOne = true;

      FinalValueOne = this.CheckDuree(that.Montant).FinalValue;

      Control.Montant = this.CheckDuree(that.Montant).Control;

      FinalValue = this.CheckTaux(that.Taux).FinalValue;

      Control.Taux = this.CheckTaux(that.Taux).Control;

      let FinalValueDuree = this.CheckDuree(that.Duree).FinalValue;

      Control.Duree = this.CheckDuree(that.Duree).Control;

      if (FinalValueOne == true && FinalValue && FinalValueDuree) {
        this.validateStep("15");
      } else {
        this.unvalidateStep("15");
      }
    },

    Validate16() {
      this.validateStep("16");
    },

    Validate17() {
      this.validateStep("17");
    },

    Validate18() {
      let FinalValue = "";
      let Results = "";
      let ResultsPhone = "";
      let that = this.FormularData;
      let Control = this.Control;

      FinalValue = this.CheckEmail(that.Email).FinalValue;
      Results = FinalValue;
      Control.Email = this.CheckEmail(that.Email).Control;

      FinalValue = this.CheckPhone(that.Phone).FinalValue;
      ResultsPhone = FinalValue;
      Control.Phone = this.CheckPhone(that.Phone).Control;

      if (Results == true && ResultsPhone == true) {
        this.validateStep("18");
      } else {
        this.unvalidateStep("18");
      }
    },
    
    hideElement(id) {
      document.getElementById(id).classList.add("hideclass");
    },
    showElement(id) {
      document.getElementById(id).classList.remove("hideclass");
    },

    Submit() {
    },

    clearDate() {
      this.FormularData.NaissanceDate = null;
    },
    logging() {},

    SendForm() {
      let FinalValue = true;
      let that = this.FormularData;
      let there = this;
      let Control = this.Control;

      let Results = [];
      FinalValue = this.CheckEntityisNotEmpty(that.DateEffet).FinalValue;
      Results.push(FinalValue);
      Control.DateEffet = this.CheckEntityisNotEmpty(that.DateEffet).Control;

      FinalValue = this.CheckEntityisNotEmpty(that.AssureeOne.Nom).FinalValue;
      Results.push(FinalValue);
      Control.NomAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Nom
      ).Control;

      FinalValue = this.CheckEntityisNotEmpty(
        that.AssureeOne.Prenom
      ).FinalValue;
      Results.push(FinalValue);
      Control.PrenomAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Prenom
      ).Control;

      FinalValue = this.CheckEntityisNotEmpty(
        that.AssureeOne.Naissance
      ).FinalValue;
      Results.push(FinalValue);
      Control.NaissAssuree1 = this.CheckEntityisNotEmpty(
        that.AssureeOne.Naissance
      ).Control;

      if (this.FormularData.CarAdress != null) {
        FinalValue = true;
      } else {
        FinalValue = false;
      }

      Results.push(FinalValue);

      FinalValue = this.CheckEntityisNotEmpty(that.Profession).FinalValue;
      Results.push(FinalValue);
      Control.Profession = this.CheckEntityisNotEmpty(that.Profession).Control;

      if (that.Genre.length == 0) {
        FinalValue = false;
        Results.push(FinalValue);
        Control.Genre = true;
      } else {
        if (that.Genre.length == 2) {
          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Nom
          ).FinalValue;
          Results.push(FinalValue);
          Control.NomAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Nom
          ).Control;

          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Prenom
          ).FinalValue;
          Results.push(FinalValue);
          Control.PrenomAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Prenom
          ).Control;

          FinalValue = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Naissance
          ).FinalValue;
          Results.push(FinalValue);
          Control.NaissAssuree2 = this.CheckEntityisNotEmpty(
            that.AssureeTwo.Naissance
          ).Control;
        }
      }

      if (that.Typepret == "Autre") {
        FinalValue = this.CheckEntityisNotEmpty(that.AutrePret).FinalValue;
        Results.push(FinalValue);
        Control.AutrePret = this.CheckEntityisNotEmpty(that.AutrePret).Control;
      } else {
        Control.AutrePret = true;
      }

      if (that.Organisme == "Autre") {
        FinalValue = this.CheckEntityisNotEmpty(that.AutreOrganisme).FinalValue;
        Results.push(FinalValue);
        Control.AutreOrganisme = this.CheckEntityisNotEmpty(
          that.AutreOrganisme
        ).Control;
      } else {
        Control.AutreOrganisme = true;
      }

      FinalValue = this.CheckDuree(that.Duree).FinalValue;
      Results.push(FinalValue);
      Control.Duree = this.CheckDuree(that.Duree).Control;
      FinalValue = this.CheckDuree(that.Montant).FinalValue;
      Results.push(FinalValue);
      Control.Montant = this.CheckDuree(that.Montant).Control;
      FinalValue = this.CheckTaux(that.Taux).FinalValue;
      Results.push(FinalValue);
      Control.Taux = this.CheckTaux(that.Taux).Control;
      FinalValue = this.CheckEmail(that.Email).FinalValue;
      Results.push(FinalValue);
      Control.Email = this.CheckEmail(that.Email).Control;
      let FinalResult = true;
      for (let i = 0; i < Results.length; i++) {
        if (Results[i] == false) {
          FinalResult = false;
        }
      }
      if (FinalResult == true) {
        there.isLoading = true;
        let jsonText = '{"Formular":' + JSON.stringify(this.FormularData) + "}";
        axios
          .post(
            `https://endpoint.demander-un-devis.capiassur.fr/emprunter/submitinsurance`,
            jsonText,
            {
              headers: {
                "content-type": "application/json",
              },
            }
          )
          .then(function (res) {
            let response = res.data.respondeCode;
            if (response == 200) {
              document.getElementById("message").style.display = "block";
              document.getElementById("formularor").style.display = "none";
              there.isLoading = false;
            }
          })
          .catch(function () {
            there.isLoading = false;
          });
      }
    },
    onComplete() {
      let there = this;
      there.isLoading = true;
      there.FormularData.Bref = "123fabmiolodnefnej546";
      this.SendForm();
    },
    reset() {
      for (let field in this.formData) {
        this.formData[field] = null;
      }
    },
    nextStep() {
      this.currentTab = this.currentTab + 1;
    },
    previousStep() {
      //alert("On Previous Step");
    },
    openTogglerDate(id) {
      document.getElementById(id).click();
    },
    filtreTexteForPostalCode(arr, requete) {
      return arr.filter(function (el) {
        return (
          el.codePostal.toLowerCase().indexOf(requete.toLowerCase()) !== -1 ||
          el.nomCommune.toLowerCase().indexOf(requete.toLowerCase()) !== -1
        );
      });
    },

    getCachedProfile() {
      let Cached = [];
      Cached["FirstName"] = localStorage.FirstName;
      Cached["LastName"] = localStorage.LastName;
      Cached["Email"] = localStorage.Email;
      Cached["PhoneNumber"] = localStorage.PhoneNumber;
      Cached["Naissance"] = localStorage.Naissance;
      Cached["IsConnected"] = localStorage.isConnected;
      return Cached;
    },
    setCachedProfile(
      FirstName = "",
      LastName = "",
      Email = "",
      PhoneNumber = "",
      Naissance = "",
      isConnected = 0
    ) {
      localStorage.FirstName = FirstName;
      localStorage.LastName = LastName;
      localStorage.Email = Email;
      localStorage.PhoneNumber = PhoneNumber;
      localStorage.Naissance = Naissance;
      localStorage.isConnected = isConnected;
    },
    reloadCached() {
      let Cached = this.getCachedProfile();
      this.FormularData.Nom = Cached["FirstName"];
      this.FormularData.Prenom = Cached["LastName"];
      this.FormularData.Email = Cached["Email"];
      this.FormularData.NaissanceDate = Cached["Naissance"];
      this.FormularData.Phone = Cached["PhoneNumber"];
      this.isConnected = Cached["IsConnected"];
    },
    profileTraitement(data) {
      let response = data.data.success;
      let rep = data.data;

      if (response) {
        this.setCachedProfile(
          rep.FirstName,
          rep.LastName,
          rep.Email,
          rep.PhoneNumber,
          rep.Naissance,
          1
        );
        this.reloadCached();
      }else{
        this.isConnected = 0;
      }
    },
   


    fetchAdress(adresse){
      this.temporarCodes = [];
        for(let i=0;i<adresse.length;i++){
          let me = {
           codePostal :adresse[i].properties.postcode,
           nomCommune :adresse[i].properties.label
        };
          this.temporarCodes.push(me);
        }
    },
    getAsyncData: debounce(function (name) {
      if (!name.length) {
        this.data = [];
        return;
      }
      this.isFetching = true; 
      if (name.length > 3) {
        axios
          .get(
            "https://api-adresse.data.gouv.fr/search/?q="+name+"&type=housenumber&autocomplete=1")
          .then(
            (response) => (this.fetchAdress(response.data.features)) //this.Brands = response.data.Brands
          )
          .catch();
      }
      this.isFetching = false;
    }, 500),
  },
};
</script>
<style scoped>
.header {
  background-color: rgb(51, 51, 243);
  width: 100%;
  height: 90px;
}
@import url('../../assets/common.css');
@import url('../../assets/mystyle.css');
@import url('../../assets/stepper.css');
@import url('../../assets/buefy.css');
</style>